<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
          <span v-for="(err, index) in validation_errors" :key="index">{{ err[0] }} <br/></span>
        </div>
        <form action="">
          <div class="form-row">
            <div class="col-md-4">
              <select v-model="search_data.month" v-validate="{ required: true }"  id="month" name="month" class="form-control form-control-sm">
                <option selected disabled :value="''">Select a month</option>
                <option v-for="(month, index) in months" :key="index" :value="index">{{ month }}</option>
              </select>
              <div class="invalid-feedback">Month is required</div>
            </div>
            <div class="col-md-4">
              <select v-model="search_data.year" v-validate="{ required: true }"  id="year" name="year" class="form-control form-control-sm">
                <option selected disabled :value="''">Select a year</option>
                <option v-for="(year, index) in years" :key="index" :value="index">{{ year }}</option>
              </select>
              <div class="invalid-feedback">Year is required</div>
            </div>
            <div class="col-md-4">
              <a-button class="btn btn-success btn-block" :loading="btnLoading" @click.prevent="downloadExcel()"><i class="fa fa-download mr-1" aria-hidden="true"></i>Download</a-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/axios'

export default {
  name: 'monthly_hub_store_report',
  components: { },
  data() {
    return {
      btnLoading: false,
      validation_errors: {},
      show: false,
      hub_file: '',
      months: [],
      years: [],
      search_data: {
        month: '',
        year: '',
      },
    }
  },
  mounted() {
    this.codes()
  },
  methods: {
    downloadExcel() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.btnLoading = true
          apiClient.post('api/hub/monthly-report-export', this.search_data, { responseType: 'blob' }).then(response => {
            this.btnLoading = false
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'monthly_hub_status_report.xlsx')
            document.body.appendChild(link)
            link.click()
          }).catch(error => {
            this.btnLoading = false
            this.validation_errors = error.response.data.errors
            this.show = true
            this.hide()
          })
        }
      })
    },
    codes() {
      this.months = this.$months()
      this.years = this.$years()
    },
    hide() {
      setTimeout(() => {
        this.show = false
      }, 5000)
    },
  },
}
</script>

<style scoped>
.form-control-sm {
  height: calc(1.7em + .5rem + 2px) !important;
}
</style>
